(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["casa-resenas-fotos"] && !Shopify.designMode) return;
  try {
    class CasaResenasFotos extends HTMLElement {
    connectedCallback() {
      this.tira = this.querySelector('.casa-fotos-resenas__tira');
      this.visor = this.querySelector('.casa-fotos-resenas__visor');
      this.fotos = [];
      this.actual = 0;
      this.cargar();
    }

    get clave() {
      return 'casa-fotos-resenas:' + this.dataset.productId;
    }

    async cargar() {
      try {
        let fotos = null;
        try {
          const cache = sessionStorage.getItem(this.clave);
          if (cache) fotos = JSON.parse(cache);
        } catch (e) { fotos = null; }
        if (!fotos) {
          fotos = await this.pedir();
          try { sessionStorage.setItem(this.clave, JSON.stringify(fotos)); } catch (e) { /* sin storage */ }
        }
        this.fotos = fotos.slice(0, parseInt(this.dataset.max || '12', 10));
        if (!this.fotos.length) return;
        this.pintar();
        this.hidden = false;
      } catch (e) {
        /* sin fotos o sin red: el bloque se queda oculto */
      }
    }

    async pedir() {
      const shop = this.dataset.shop;
      const id = this.dataset.productId;
      const fotos = [];
      for (let page = 1; page <= 2 && fotos.length < 24; page++) {
        const url = 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop)
          + '&shop_domain=' + encodeURIComponent(shop)
          + '&platform=shopify&per_page=10&page=' + page
          + '&product_id=' + encodeURIComponent(id) + '&sort_by=with_pictures';
        const r = await fetch(url, { mode: 'cors', credentials: 'omit' });
        if (!r.ok) break;
        const data = await r.json();
        const doc = new DOMParser().parseFromString(data.html || '', 'text/html');
        const revs = doc.querySelectorAll('.jdgm-rev');
        if (!revs.length) break;
        revs.forEach((rev) => {
          const autor = (rev.querySelector('.jdgm-rev__author') || {}).textContent || '';
          const score = parseInt((rev.querySelector('.jdgm-rev__rating') || {}).getAttribute?.('data-score') || '0', 10);
          const titulo = (rev.querySelector('.jdgm-rev__title') || {}).textContent || '';
          const cuerpo = (rev.querySelector('.jdgm-rev__body') || {}).textContent || '';
          rev.querySelectorAll('.jdgm-rev__pic-link').forEach((a) => {
            const href = a.getAttribute('data-mfp-src') || a.getAttribute('href');
            if (!href) return;
            fotos.push({
              grande: href.replace(/width=\d+/, 'width=1024'),
              chica: href.replace(/width=\d+/, 'width=320'),
              autor: autor.trim(),
              score: score,
              texto: (titulo.trim() ? titulo.trim() + ' · ' : '') + cuerpo.trim()
            });
          });
        });
        if (revs.length < 10) break;
      }
      return fotos;
    }

    estrellas(n) {
      return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
    }

    pintar() {
      const frag = document.createDocumentFragment();
      this.fotos.forEach((f, i) => {
        const li = document.createElement('li');
        li.className = 'casa-fotos-resenas__item';
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'casa-fotos-resenas__boton';
        b.setAttribute('aria-label', (f.autor || 'Cliente') + ' · ' + f.score + ' de 5');
        const img = document.createElement('img');
        img.src = f.chica;
        img.alt = '';
        img.loading = i < 4 ? 'eager' : 'lazy';
        img.width = 320;
        img.height = 320;
        b.appendChild(img);
        const s = document.createElement('span');
        s.className = 'casa-fotos-resenas__mini-estrellas';
        s.textContent = '★ ' + f.score;
        b.appendChild(s);
        b.addEventListener('click', () => this.abrir(i));
        li.appendChild(b);
        frag.appendChild(li);
      });
      this.tira.replaceChildren(frag);

      this.querySelector('.casa-fotos-resenas__cerrar').addEventListener('click', () => this.visor.close());
      this.querySelector('.casa-fotos-resenas__prev').addEventListener('click', () => this.ir(-1));
      this.querySelector('.casa-fotos-resenas__next').addEventListener('click', () => this.ir(1));
      this.visor.addEventListener('click', (e) => { if (e.target === this.visor) this.visor.close(); });
      this.visor.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.ir(-1);
        if (e.key === 'ArrowRight') this.ir(1);
      });
    }

    abrir(i) {
      this.actual = i;
      this.mostrar();
      if (typeof this.visor.showModal === 'function') this.visor.showModal();
      else this.visor.setAttribute('open', '');
    }

    ir(delta) {
      this.actual = (this.actual + delta + this.fotos.length) % this.fotos.length;
      this.mostrar();
    }

    mostrar() {
      const f = this.fotos[this.actual];
      const img = this.visor.querySelector('.casa-fotos-resenas__grande');
      img.src = f.grande;
      img.alt = (f.autor || 'Cliente') + ' · foto de su reseña';
      this.visor.querySelector('.casa-fotos-resenas__estrellas').textContent = this.estrellas(f.score);
      this.visor.querySelector('.casa-fotos-resenas__autor').textContent = f.autor || 'Cliente verificado';
      this.visor.querySelector('.casa-fotos-resenas__texto').textContent = f.texto;
      this.visor.querySelector('.casa-fotos-resenas__contador').textContent = (this.actual + 1) + ' / ' + this.fotos.length;
    }
  }

  if (!customElements.get('casa-resenas-fotos')) {
    customElements.define('casa-resenas-fotos', CasaResenasFotos);
  }
  } catch(e) { console.error(e); }
})();

})();
